/*
Returns basic Uterum properties set in URL params
on navigation from LFC -> BFC step 4.
*/

export const scrapePropertiesFromUrlParams = () => {
  if ("URLSearchParams" in window) {
    const urlParams = new URLSearchParams(window.location.search);

    const Season = urlParams.get("season");
    urlParams.delete("season");

    const FrameType = urlParams.get("type");
    urlParams.delete("type");

    const FrameWidth = urlParams.get("nwidth");
    urlParams.delete("nwidth");

    const FrameDepth = urlParams.get("ndepth");
    urlParams.delete("ndepth");

    const FrameAddonWidth = urlParams.get("naddonwidth");
    urlParams.delete("naddonwidth");

    const Corners = urlParams.get("corner");
    urlParams.delete("corner");

    const Color = urlParams.get("color");
    urlParams.delete("color");

    const newRelativePathQuery =
      urlParams.toString().length > 0
        ? window.location.pathname + "?" + urlParams.toString()
        : window.location.pathname;
    history.replaceState(null, "", newRelativePathQuery);

    return {
      Season,
      FrameType,
      FrameWidth,
      FrameDepth,
      FrameAddonWidth,
      Corners,
      Color,
    };
  }

  return null;
};
